import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { usePageContext } from '@merchant-portal/framework';

const PageHeader = ({ renderElementIfMarbleIsDisabled, children, ...otherProps }) => {
  const { setPageContext = () => {} } = usePageContext();

  useEffect(() => {
    setPageContext(otherProps);

    return () => {
      setPageContext({
        title: '',
        description: '',
      });
    };
  }, []);

  return children;
};

PageHeader.propTypes = {
  backNavigation: PropTypes.shape({
    label: PropTypes.string,
    path: PropTypes.string,
  }),
  description: PropTypes.string,
  renderElementIfMarbleIsDisabled: PropTypes.node,
  title: PropTypes.string,
};

export default PageHeader;
